import { DateTime } from 'luxon';
import { App, BarkerApi, TmdbApi } from './interfaces';

export class Utils {

  static convertApiEventListingToAppEventListing(eventListing: BarkerApi.EventListing): App.EventListing {

    return {
      id: eventListing.id,
      event: {
        id: eventListing.event.id,
        title: eventListing.event.title,
        link: eventListing.event.link
      },
      calendarItem: {
        title: eventListing.event.title,
        start_time: new Date(eventListing.start_time),
        end_time: new Date(eventListing.end_time)
      },
      extra: eventListing.extra,
      tickets_link: eventListing.tickets_link,
      premiere: eventListing.premiere
    } as App.EventListing;

  }

  static getImageUrl(path: string, size = 'w320') {

    return `https://image.tmdb.org/t/p/${size}${path}`;

  }

  static formatDate(date?: string) {

    if (date) {

      return new Date(date).toString();

    } else {

      return '';

    }

  }

  static getMovieTitleWithReleaseYear(title: string, date?: string) {

    return (date) ? `${title} (${new Date(date).getFullYear().toString()})` : `${title}`;

  }

  static getUtcDateString(date: Date) {

    return DateTime.fromJSDate(date).setZone('UTC').toFormat('yyyy-MM-dd HH:mm:ss');

  }

  static convertTmdbResultToBarkerMovie(movie: TmdbApi.MovieResult.RootObject, region = 'US') {

    const release_date = movie.release_dates.results.filter(
        (global_release_dates) => global_release_dates.iso_3166_1 === region
      ).map(
        (country_release_dates) => country_release_dates.release_dates.filter(
          (all_release_dates) => all_release_dates.type === 3
        ).map(
          (theatrical_releases) => theatrical_releases
        )
      ).map(
        (result) => result[0]
      );

    let theatrical_release = null;
    let theatrical_film_ratings: string[] = [];

    if (release_date[0]) {

      theatrical_release = new Date(release_date[0].release_date);
      theatrical_film_ratings = [release_date[0].certification];

    }

    const languages = movie.spoken_languages.slice(0, 5).map( (language) => language.name);
    const genres = movie.genres.slice(0, 5).map(genre => genre.name);
    const countries = movie.production_countries.slice(0, 5).map(country => country.name);
    const directors = movie.credits.crew.filter( (crew) => crew.job === 'Director').slice(0, 5).map( crew => crew.name);
    const actors = movie.credits.cast.slice(0,5).map( cast => cast.name)
    const poster = (movie.images.posters.length > 0 ) ? movie.images.posters.map(poster => poster.file_path)[0] : null;
    const backdrop = (movie.images.backdrops.length > 0 ) ? movie.images.backdrops.map(backdrop => backdrop.file_path)[0] : null;
    const trailer = (movie.videos.results.length > 0 ) ? movie.videos.results.map(video => video.key)[0] : null;

    return {
      title: movie.title,
      overview: movie.overview,
      release_date: theatrical_release,
      tagline: movie.tagline,
      homepage: movie.homepage,
      movie_rating: movie.vote_average,
      imdb_id: movie.imdb_id,
      revenue: movie.revenue,
      budget: movie.budget,
      runtime: movie.runtime,
      film_ratings: theatrical_film_ratings,
      languages,
      genres,
      countries,
      directors,
      actors,
      poster,
      backdrop,
      trailer
    } as App.Tmdb.Movie;

  }

}



// WEBPACK FOOTER //
// ./resources/src/components/utils.ts